// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    userScope: z.string().min(1).max(64),
});
const guard = z.object({
    tenantId: z.string().max(21),
    userScope: z.string().min(1).max(64),
});
export const CimdUserScopes = Object.freeze({
    table: 'cimd_user_scopes',
    tableSingular: 'cimd_user_scope',
    fields: {
        tenantId: 'tenant_id',
        userScope: 'user_scope',
    },
    fieldKeys: [
        'tenantId',
        'userScope',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
